import DatePicker from "react-datepicker";
import React from 'react'
import {Button,  Container,  Dimmer,  Dropdown,  Form,  Grid,  Icon,  Loader,  Radio} from 'semantic-ui-react'
import { inject, observer } from 'mobx-react';

import { CustomerTable } from './components';
import './form.css';
import "react-datepicker/dist/react-datepicker.css";
import { customerColumns } from './constants'

@inject('CustomerStore')
@observer
export default class CustomerForm extends React.Component {

  constructor(props) {
    super(props)
    this.customerStore = this.props.CustomerStore
    this.customerStore.professionsLoad()
    this.customerStore.updateCustomerBirthDate()
  }

  render() {
    return (
      <Grid>
        <Form onSubmit={this.customerStore.handleCustomerForm}>
          <Dimmer active={this.customerStore.isLoading} inverted><Loader /></Dimmer>
          <Form.Group widths='equal'>
            <Form.Field>
              <label data2='ok' data1={this.customerStore.customer.user.last_name}>É Profissional?</label>
              <Radio
                checked={this.customerStore.customer.is_seller}
                name="is_seller"
                onChange={this.customerStore.handleRadioIsSeller}
                toggle
                type='radio'
              />
            </Form.Field>
            <Form.Input
              id="customer_name"
              label="Nome:"
              name="first_name"
              onChange={this.customerStore.handleUserChange}
              placeholder="Informe o nome do cliente"
              value={this.customerStore.customer.user.first_name}
            />

            <Form.Input
              id="customer_lastname"
              label="Sobreneme:"
              name="last_name"
              onChange={this.customerStore.handleUserChange}
              placeholder="Informe o sobrenome completo do cliente"
              value={this.customerStore.customer.user.last_name}
            />

            <Form.Input
              id="customer_cpf"
              label="CPF:"
              name="cpf"
              onChange={this.customerStore.handleGenericChange}
              placeholder="Informe o número do cnpj do cliente"
              value={this.customerStore.customer.cpf}
            />
            <Form.Field>
              <label htmlFor="customer_birth">Data Nasc</label>
              <DatePicker
                // dateFormat="dd/MM/yyyy"
                id="customer_birth"
                name="birth_date"
                onChange={this.customerStore.handleDatePicker}
                selected={this.customerStore.birthDate}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths='equal'>
            <Form.Field>
              <label htmlFor="customer_profession">Profissão</label>
              <Dropdown id="customer_profession" name="profession" clearable={true} selection options={this.customerStore.professionsOptions} onChange={this.customerStore.handleGenericChange} />
            </Form.Field>
            <Form.Input
              id="customer_email"
              label="Email"
              type="email"
              name="email"
              onChange={this.customerStore.handleUserChange}
              value={this.customerStore.customer.user.email}
            />
            <Form.Input
              id="customer_cellphone"
              label="Celular:"
              name="cellphone"
              onChange={this.customerStore.handleGenericChange}
              placeholder="Informe o ceular do cliente"
              value={this.customerStore.customer.cellphone}
            />
            <Form.Field>
              <label htmlFor="customer_who_indicated">Indicação</label>
              <Dropdown
                clearable={true}
                id="customer_who_indicated"
                name="who_indicated"
                onChange={this.customerStore.handleGenericChange}
                onSearchChange={this.customerStore.whoIndicatedSearchEvent}
                options={this.customerStore.whoIndicatedOptions}
                search
                selection
              />
            </Form.Field>
          </Form.Group>
          <Form.Group><CustomerAdressForm /></Form.Group>
          <Form.Group>
            <Button
              className="signin-button"
              color="teal"
              fluid size="large"
              type="submit"
            >Salvar</Button>
          </Form.Group>
        </Form>
        {this.customerStore.customersList.length >0 ? <CustomerTable data={this.customerStore.customersList} columns={customerColumns} getTrProps={this.customerStore.onClickTableRow} />: <></>}
      </Grid>
    )
  }
}


@inject('CustomerStore')
@observer
export class CustomerAdressForm extends React.Component {
  constructor(props) {
    super(props)
    this.customerStore = this.props.CustomerStore
    this.customerStore.getCustomers()
  }


  render() {
    return (
      <Container>
        <h3>Endereço</h3>
        <Grid divided='vertically'>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form.Input
                label="Pesquisar"
                icon={<Icon name='search' inverted circular link onClick={this.customerStore.handleSearchAddressChange} />}
                onChange={this.customerStore.handleSearchAddressChange}
                value={this.customerStore.search_address}
                name="search_address"
                type="text"
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Input id="customer_postcode" label="CEP" type="text" name="postcode" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.postcode} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Form.Input id="customer_city" label="Cidade" type="text" name="city" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.city} />
            </Grid.Column>
            <Grid.Column>
              <Form.Input id="customer_state" label="UF" type="text" name="state" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.state} />
            </Grid.Column>
            <Grid.Column>
              <Form.Input id="customer_country" label="Pais" type="text" name="country" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.country} />
            </Grid.Column>
            <Grid.Column>
              <Form.Input id="customer_neighborhood" label="Bairro" type="text" name="neighborhood" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.neighborhood} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={3}>
            <Grid.Column>
              <Form.Input id="customer_street_address" label="Endereço" type="text" name="street_address" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.street_address} />
            </Grid.Column>
            <Grid.Column>
              <Form.Input id="customer_number" label="Numero" type="text" name="number" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address['number']} />
            </Grid.Column>
            <Grid.Column>
              <Form.Input id="customer_complement" label="Complemento" type="text" name="complement" onChange={this.customerStore.handleAddressChange} value={this.customerStore.customer.address.complement} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}
